import { useNavigate } from "react-router-dom"
import { useSetRecoilState } from "recoil"
import { clientState } from "recoils/clientState"
import { companyState } from "recoils/companyState"
import { recruitsState } from "recoils/recruitsState"
import { signOut } from "usecases/firebase/auth"

import { isInitializingFinishedState } from "../recoils/initializingState"

export const useFirebaseLogOut = () => {
  const setClient = useSetRecoilState(clientState)
  const setCompany = useSetRecoilState(companyState)
  const setRecruits = useSetRecoilState(recruitsState)
  const setIsInitialized = useSetRecoilState(isInitializingFinishedState)

  const navigate = useNavigate()

  return () => {
    signOut()
      .then(() => {
        setClient(null)
        setCompany(null)
        setRecruits([])
        setIsInitialized(false)
        navigate("/login")
      })
      .catch((e) => console.log(e))
  }
}
